import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { FormikErrors } from 'formik';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import {
    ExternalCustomerMapping,
    ExternalCustomerMappingUpdateRequest,
    FormValues,
} from '../../../../components/external-customer-mapping/external-customer-mapping';
import { SupplierExternalCustomerMappingApi } from '../api/supplier-external-customer-mapping-api';

const api = new SupplierExternalCustomerMappingApi(API_BASE_URL);

export const getExternalCustomerMappings = createAsyncThunk(
    'supplier/getExternalCustomerMappings',
    async (params: { supplierId: number }, thunkAPI) => {
        const response = await api.getExternalCustomerMappings(params.supplierId);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const updateStoreExternalCustomerMapping = createAction<{
    formData: FormValues;
    isDirty: boolean;
    isValid: boolean;
    errors: FormikErrors<FormValues>;
}>('supplier/updateStoreExternalCustomerMapping');

export const saveExternalCustomerMappings = createAsyncThunk(
    'supplier/saveExternalCustomerMappings',
    async (params: { supplierId: number; externalCustomerMappings: ExternalCustomerMapping[] }, thunkAPI) => {
        const mappings = params.externalCustomerMappings.map(mapping => {
            return {
                id: mapping.id,
                customerId: mapping.accountId,
                supplierId: params.supplierId,
                externalCustomerId: mapping.externalCustomerId,
            } as ExternalCustomerMappingUpdateRequest;
        });
        const response = await api.updateExternalCustomerMappings(params.supplierId, mappings);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return null;
        }

        return response;
    }
);

export const deleteExternalCustomerMapping = createAsyncThunk(
    'supplier/deleteExternalCustomerMapping',
    async (params: { supplierId: number; externalCustomerMappingId: number }, thunkAPI) => {
        if (params.externalCustomerMappingId > 0) {
            const response = await api.deleteExternalCustomerMappings(
                params.supplierId,
                params.externalCustomerMappingId
            );

            if (response.success === false) {
                thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
                return null;
            }
            thunkAPI.dispatch(
                Snackbar.enqueue(
                    Snackbar.PoolNotification.success(
                        'app.bonusSettlementsSupplierOverview.action.removeSupplier.success'
                    )
                )
            );
        }

        return params.externalCustomerMappingId;
    }
);
